import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-single-view-org',
  template: `
  <g10-master-layout>

    <div class="g10-master-titlebar-content-data">
    <title-bar [titleName]="'View Organization'" [buttonType]="'view'" [routeLink]="'/master/organization/view-org'" [buttonName]="'Organization List'" class="p-0 m-0"></title-bar>
    </div>
    
    <div class="g10-master-main-content-data">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-12 mt-3">
      
            <g10-ms-card *ngIf="orgData">
              <div card-content>
                <div class="row mt-2">
                  <div class="col-lg-3 col-md-4 col-12 text-center">
                    <h6>
                      <img src="{{orgData.profile}}" width="90" >
      
                    </h6>
                    <h5> {{orgData.orgName | titlecase}}</h5>
                    <p> {{orgData.orgEmail | lowercase}}</p>
                  </div>
                  <div class="col-lg-9 col-md-8 col-12">
                    <div class="row">
                      <div class="col-xl-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Contact Name">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/name.png" width="20"></p>
                        <div class="row">
                          <div class="col-12 px-4">
                            <div class="row">
                              <div class="col-2"><span class="badge badge-primary" matToolip="Primary" title="Primary">P</span></div>
                              <div class="col pl-1"> {{orgData.primaryContactName | titlecase}} </div>
                            </div>
                            <div class="row">
                              <div class="col-2"><span class="badge badge-secondary" matToolip="Secondary" title="Secondary">S</span></div>
                              <div class="col pl-1"> {{orgData.secondaryContactName | titlecase}} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Roles">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/driver/work.png" width="20"></p>
                        <div class="row">
                          <div class="col-12 px-4">
                            <div class="row">
                              <div class="col-2"><span class="badge badge-primary" matToolip="Primary" title="Primary">P</span></div>
                              <div class="col pl-1"> {{orgData.primaryContactRole | titlecase}} </div>
                            </div>
                            <div class="row">
                              <div class="col-2"><span class="badge badge-secondary" matToolip="Secondary" title="Secondary">S</span></div>
                              <div class="col pl-1"> {{orgData.secondaryContactRole | titlecase}} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Mobile">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/phone-call.png" width="20"></p>
                        <div class="row">
                          <div class="col-12 px-4">
                            <div class="row">
                              <div class="col-2 "><span class="badge badge-primary" matToolip="Primary" title="Primary">P</span></div>
                              <div class="col pl-1"> {{orgData.primaryContactNumber}} </div>
                            </div>
                            <div class="row">
                              <div class="col-2"><span class="badge badge-secondary" matToolip="Secondary" title="Secondary">S</span></div>
                              <div class="col pl-1"> {{orgData.secondaryContactNumber}} </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-3 col-lg-4 col-md-8 col-sm-6 col-12 my-2 py-2" title="Email">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/email.png" width="20"></p>
                        <div class="row">
                          <div class="col-12 px-4">
                            <div class="row">
                              <div class="col-1"><span class="badge badge-primary" matToolip="Primary" title="Primary">P</span></div>
                              <div class="col"> {{orgData.primaryContactEmail | lowercase}} </div>
                            </div>
                            <div class="row">
                              <div class="col-1"><span class="badge badge-secondary" matToolip="Secondary" title="Secondary">S</span></div>
                              <div class="col"> {{orgData.secondaryContactEmail | lowercase}} </div>
                            </div>
                          </div>
                        </div>
                      </div>
      
                      <div class="col-xl-3 col-md-4 col-sm-6 col-12 my-2 py-2 " title="Pincode">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/mail.png" width="20"></p>
                        <p class="text-center">{{orgData.pincode}} </p>
                      </div>
      
                      <div class="col-xl-3 col-md-4 col-sm-6 col-12  my-2 py-2" title="Address">
                        <p class="text-center">
                          <img src="../../../../../../../assets/images/information/vendor/home.png" width="20">
                        </p>
                        <p class="text-center">
                          {{orgData.address | titlecase}}
                        </p>
                      </div>
                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="City">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/safe-zone.png" width="20"></p>
                        <p class="text-center">{{orgData.city | titlecase}}
                        </p>
                      </div>
      
                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="State">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/driver/state.png" width="20"></p>
                        <p class="text-center">{{orgData.state | titlecase}}
                        </p>
                      </div>
                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Country">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/time-zone.png" width="20"></p>
                        <p class="text-center">{{orgData.country | titlecase}}
                        </p>
                      </div>
      
                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Website">
                        <p class="text-center"> <img src="../../../../../../../assets/images/information/vendor/domain.png" width="20"></p>
                        <p class="text-center">{{orgData.website}}
                        </p>
                      </div>

                      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 my-2 py-2" title="Map">
                        <p class="text-center"> <i class="fas fa-map-marked-alt text-primary" style="font-size: 20px;"></i></p>
                        <p class="text-center">{{orgData.map=='google'?'Google':'Open Street'}}
                        </p>
                      </div>
                      </div>
                  </div>
                </div>
              </div>
            </g10-ms-card>
            <g10-ms-card *ngIf="!orgData">
              <h2>
                No data found
              </h2>
            </g10-ms-card>
          </div>
        </div>
      </div>
    </div>
</g10-master-layout>

    `
})


export class SingleOrgViewComponent implements OnInit {
  public orgID: any;
  orgData: any;
  constructor(
    public api: ApiService,
    public router: Router,
    private route: ActivatedRoute,
    public storage: StorageService,

  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.orgID = params.params.orgID;
    });
  }

  ngOnInit() {
    this.getOrgInfo();
  }

  getOrgInfo() {
    const data = {
      orgID: this.orgID
    };
    this.api.listOrg(data).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.orgData = res.data[0];
      }

      // console.log('slected org---> ', this.orgData);
    }).catch((err) => {
      console.log(err);
    });
  }

}
